import React from 'react'
import { useLocation } from 'react-router-dom';
import { Navigate } from 'react-router-dom'
import Forbidden from '../screens/Forbidden';

/*
Priority:
1. Permission
2. Role

If a permission is required, it will take priority over any role provided.

*/

/*
MVP: For MVP we will only support admin users having an isAdmin = true property. Later we may expand to roles and permissions
*/
const ProtectedRoute = ({ isAuthenticated, children, user = null, adminRequired = false }) => {
  const location = useLocation();

  /*
  const userHasRequiredRole = () => {
    return userRoles.includes(roleRequired);
  }

  if(user && isAuthenticated) {
    userPermissions = getPermissionNamesFromUser(user);
    userRoles = ExtractRoleNamesFromUser(user); 
  } 
  */

  return (
    (adminRequired && isAuthenticated && user?.isAdmin) ?
      children :
    (adminRequired && isAuthenticated && !user?.isAdmin) ?
      <Forbidden /> :
    (adminRequired && !isAuthenticated) ?
      <Forbidden /> :
    isAuthenticated ?
      children :
      <Navigate to={`/authenticate?continueWith=${location.pathname}`} />
  )
} 

export default ProtectedRoute;